import React from "react";
import { Box } from "@material-ui/core";

import { FinancialActivity } from "../../../api/services";
import { FinancialIcon } from "../../../icons";
import { ActivityListItem } from "./ActivityListItem";
import { useFinancialActivity } from "../hooks/useFinancialActivity";
import { ActivitySummaryCell } from "./ActivitySummaryCell";

export const FinancialActivityItem: React.FC<{
  activity: FinancialActivity;
}> = ({ activity }) => {
  const { activityDttm } = activity;
  const { title, suffix, isPending, link } = useFinancialActivity(activity);

  return (
    <ActivityListItem
      icon={<FinancialIcon />}
      title={
        <Box color={isPending ? "text.secondary" : "text.primary"}>
          <Box component="span">
            {title}
            {suffix && (
              <Box component="span" fontSize={11} ml={0.5}>
                {suffix}
              </Box>
            )}
          </Box>
        </Box>
      }
      activityDttm={activityDttm}
      isPending={isPending}
      linkTo={link}
    />
  );
};

export const FinancialActivitySummaryCell: React.FC<{
  activity: FinancialActivity;
  isGrey?: boolean;
}> = ({ activity, isGrey }) => {
  const { title, suffix } = useFinancialActivity(activity);
  return (
    <ActivitySummaryCell
      isGrey={!!isGrey}
      icon={<FinancialIcon />}
      summary={`${title} ${suffix || ""}`}
    />
  );
};
